import React, { Component } from 'react';
import Radium from 'radium';

import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';

import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import PersonIcon from '@material-ui/icons/Person';
import NoPersonIcon from '@material-ui/icons/PersonOutline';
import HelpIcon from '@material-ui/icons/Help';
import EyeIcon from '@material-ui/icons/RemoveRedEye';

import SearchContainer from './SearchContainer';
import FeatureEditorContainer from './FeatureEditorContainer';
import FeatureCreatorContainer from './FeatureCreatorContainer';

import AuthContainer from './AuthContainer';

import 'font-awesome/css/font-awesome.min.css';
import './sidebar.custom.css'
import FeedbackComponent from "./FeedbackComponent";

class SidebarComponent extends Component {
    state = {}

    render () {

        const { selected, loading, classes, showingFilters,
            isWaitingForResponse, openPanel, onAddModeChange, onCollapseSidebar,
            changeShowFilters, authorizedUser, accessibilityVersion, setAccessibilityVersion } = this.props

        const sidebarStyle = loading ? {display: 'none'} : (accessibilityVersion ? {zoom: 1.2} : null)

        const editorDisabler = (selected && selected.length == 1) ? '' : 'disabled'

        return (
            <div 
                id='sidebar'
                ref='sidebar' 
                className={'sidebar sidebar-left' + (showingFilters ? ' filters-active' : '')} 
                style={sidebarStyle}
            >
                <div className='sidebar-tabs'>
                    <ul role='tablist'>
                        <li>
                            <div className='sidebar-tab _search' role='tab'>
                                <Tooltip id="tooltip-search" title="Поиск" placement='right'>
                                    <Button
                                      className={classes.button}
                                      aria-label='Search'
                                    >
                                      <SearchIcon />
                                    </Button>
                                </Tooltip>
                            </div>
                        </li>
                        {authorizedUser && authorizedUser.roles.includes('user') && !authorizedUser.roles.includes('single_object_user') ?
                        <li>
                            <div className='sidebar-tab _new' role='tab'>
                                <Tooltip id="tooltip-add" title="Добавить объект" placement='right'>
                                    <Button
                                      className={classes.button}
                                      aria-label='Add'
                                      onClick={() => {
                                        changeShowFilters(false)
                                        openPanel('new'); 
                                        onAddModeChange(true)
                                    }}
                                    >
                                      <AddIcon />
                                    </Button>
                                </Tooltip>
                            </div>
                        </li> : null}
                        <li className={editorDisabler}>
                            <div className='sidebar-tab _editor' role='tab'>
                                {/*<Button
                                  className={classes.button}
                                  disabled={editorDisabler == 'disabled'}
                                >
                                  {editMode ? <EditLocationIcon /> : <PlaceIcon />}
                                </Button>*/}
                            </div>
                        </li>
                    </ul>

                    <ul role='tablist'>
                        <li>
                            <div className='sidebar-tab _login' role='tab'>
                                <Tooltip 
                                    id="tooltip-login" 
                                    title={authorizedUser ? authorizedUser.username : "Авторизация"} 
                                    placement='right'
                                >
                                    <Button
                                      className={classes.button}
                                      aria-label='Вход'
                                      onClick={() => {
                                        openPanel(false);
                                        onCollapseSidebar(true);
                                        this.setState({isAuthOpened: true})
                                    }}
                                    >
                                      {
                                        authorizedUser ?
                                        <PersonIcon /> :
                                        <NoPersonIcon />
                                      }
                                    </Button>
                                </Tooltip>
                            </div>
                        </li>
                        <li>
                            <div className='sidebar-tab _accessibility' role='tab'>
                                <Tooltip 
                                    id="tooltip-accessibility" 
                                    title="Версия для слабовидящих"
                                    placement='right'>
                                        <Button
                                          className={classes.button}
                                          aria-label='Версия для слабовидящих'
                                          onClick={() => {
                                                setAccessibilityVersion(!accessibilityVersion)
                                                openPanel('search')
                                            }
                                        }
                                        >
                                          <EyeIcon />
                                        </Button>
                                </Tooltip>
                            </div>
                        </li>
                        <li>
                            <div className='sidebar-tab'>
                                <Tooltip id="tooltip-help" title="Сообщить о проблеме" placement='right'>
                                    {authorizedUser ? <Button
                                      className={classes.button}
                                      aria-label='Отзыв'
                                      onClick={() => {
                                          openPanel(false);
                                          onCollapseSidebar(true);
                                          this.setState({isFeedbackOpened: true});
                                      }}
                                    >
                                      <HelpIcon />
                                    </Button>
                                        : <a href={'mailto:dimaz@usyst.ru'}>
                                            <Button
                                              className={classes.button}
                                              aria-label='Отзыв'
                                            >
                                              <HelpIcon />
                                            </Button>
                                        </a>}
                                </Tooltip>
                            </div>
                        </li>
                    </ul>
                </div>

                <div className='sidebar-content'>
                    <div ref='searchSidebarPane' className='sidebar-pane' id='search' 
                    >
                        <h1 className='sidebar-header'>Поиск
                            <span className='sidebar-close'>
                                <Button className={classes.close_button}><CloseIcon /></Button>
                            </span>
                        </h1>
                        <SearchContainer />
                    </div>

                    <div className='sidebar-pane' id='editor'>
                        <h1 className='sidebar-header'>
                            <a>{
                                (!isWaitingForResponse && selected) ? `Просмотр объекта №${selected}` : null
                            }</a>
                            <span className='sidebar-close'>
                                <Button onClick={() => openPanel('search')} className={classes.close_button}><CloseIcon /></Button>
                            </span>
                        </h1>
                        <FeatureEditorContainer />
                    </div>
                    <div className='sidebar-pane' id='new'>
                        <h1 className='sidebar-header'>
                            <a>Создание объекта</a>
                            <span className='sidebar-close'>
                                <Button 
                                    onClick={() => {
                                        onAddModeChange(false);
                                        openPanel('search')
                                    }} 
                                    className={classes.close_button}>
                                    <CloseIcon />
                                </Button>
                            </span>
                        </h1>
                        <FeatureCreatorContainer />
                    </div>

                </div>
                <AuthContainer 
                    isAuthOpened={this.state.isAuthOpened}
                    closeAuth={() => {
                        openPanel('search');
                        onCollapseSidebar(false);
                        this.setState({isAuthOpened: false})
                    }}
                />
                <FeedbackComponent
                    authorizedUser={authorizedUser}
                    isFeedbackOpened={this.state.isFeedbackOpened}
                    showFeedbackDialog={(newState) => {
                        this.setState({isFeedbackOpened: newState});
                    }}
                />
            </div>
        )
    }
}

const styles = (theme => ({
      button: {
        margin: 'unset',
        width: '100%',
        height: '40px',
        padding: 'unset',
        color: 'white',
        'font-size': '12pt',
        'min-width': 'unset',
      },
      close_button: {
        margin: 'unset',
        width: '100%',
        height: '40px',
        padding: 'unset',
        color: 'rgba(30, 54, 133, 0.5)',
        'font-size': '12pt',
        'min-width': 'unset',
      },
      input: {
        display: 'none',
      },
  }));

export default Radium(withStyles(styles)(SidebarComponent))


// WEBPACK FOOTER //
// ./src/SidebarComponent.js